import React from 'react';
import styles from './PlaceLocationCard.module.scss'
import {IProduct} from 'data/interfaces/products';
import InfoCard from 'gui/pages/mainRouter/pages/ad/components/commons/infoCard';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import GoogleMap from 'gui/components/googleMap';
import ShowTheWay from 'gui/components/showTheWay';
import {
  getPlaceDetails,
  isVoucherWithPlace,
  productLatitudeSelector,
  productLongitudeSelector
} from 'data/redux/selectors/productSelector';
import AdStreet from 'gui/components/listPage/components/ad/components/adStreet';

interface IPlaceLocationCardProps {
  product?: IProduct;
}

const PlaceLocationCard = (props: IPlaceLocationCardProps) => {
  if (isVoucherWithPlace(props.product)) {
    const placeDetails = getPlaceDetails(props.product);
    if (placeDetails) {
      return (
        <InfoCard
          title="כתובת"
          icon={LocationOnRoundedIcon}
          toolTip="כתובת"
          className={styles.PlaceLocationCard}
        >
          <div className={styles.actions}>
            <AdStreet placeDetails={placeDetails}
                      className={styles.adStreet}/>
            <ShowTheWay className={styles.showtheway}
                        latitude={productLatitudeSelector(props.product)}
                        longitude={productLongitudeSelector(props.product)}/>
          </div>
          <GoogleMap address={placeDetails.formatted_address}/>
        </InfoCard>
      );
    }
  }
  return null;
};

PlaceLocationCard.defaultProps = {};

export default React.memo(PlaceLocationCard);
